// extracted by mini-css-extract-plugin
export default {"pdfLogo":"studentprofile_2_pdfLogo__O4rFV"};